import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ForwardData,
  Sender,
} from '../actions/dg-forward/dg-forward.component';

@Component({
  selector: 'app-dg-sendcasenew',
  templateUrl: './dg-sendcasenew.component.html',
  styleUrls: ['./dg-sendcasenew.component.scss'],
})
export class DgSendcasenewComponent implements OnInit {
  caseData: any;
  forwardLevel = [];
  returnLevel = [];
  senderLevel = [];
  profileAttachTitle = '';
  isProfileComponent = true; //this.flag to indetify profile Attachment Component
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 5000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = true;

  refIdList = '';
  singleData: Sender = {
    docId: null,
    alphanum_Fileno: null,
    process: null,
    recipient: [],
    selectedRadio: null,
    showMsg: false,
  };
  SENDER_DATA: Sender[] = [];
  noPesronInRetun = false;
  noPesronInForward = false;
  selectedUnit: any;
  postData = {
    refId: [],
    toUnit: [],
    toOrderNo: [],
    roleId: [],
    toMpgType: [],
    applTypeId: 1,
    movmentActionFlag: 1,
    fromGrpId: null,
    toGrpId: null,
    fromType: null,
    toType: null,
    toRoleId: null,
    delegationVO: null,
    fromGrpWS: null,
    groupLevel: null,
    groupUnitId: null,
    groupId: null,
    recall: null,
    papsFlag: false,
    line: null,
  };

  currentLevelEmpName = '';
  currentLevelEmpDsgn = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private dialogRef: MatDialogRef<DgSendcasenewComponent>
  ) {}

  ngOnInit(): void {
    this.caseData = this.data[0];
    console.log(' data from case view===', this.caseData);
    this.refIdList = this.caseData.docId.toString();

    this.getForwardData();
    this.getCurrentUserData();
  }

  getCurrentUserData(): void {
    this.http.get('/admin/user-login-dtls')?.subscribe((res: any) => {
      this.currentLevelEmpName = res?.data?.employeeVO?.empFullName;
      this.currentLevelEmpDsgn = res?.data?.employeeVO?.dsgnName;
    });
  }

  getForwardData(): void {
    let params = new HttpParams();
    params = params.append('appTypeId', '1');
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '610');
    params = params.append('recNo', this.refIdList);
    this.http
      .get('/workflow/hierarchy-details', { params: params })
      .subscribe((res: { data: ForwardData[] }) => {
        this.singleData = {
          docId: null,
          alphanum_Fileno: null,
          process: null,
          recipient: [],
          selectedRadio: null,
          showMsg: false,
        };
        this.SENDER_DATA = [];
        const restemp: { data: ForwardData[] } = res;
        if (!restemp.data.length) {
          this.singleData.recipient.push({
            empName: 'No person is mapped above you',
            unitId: 0,
          });
          this.singleData.showMsg = true;
          this.noPesronInForward = true;
          //this.showMsg = true;
        } else {
          this.singleData.showMsg = false;
          //this.showMsg = false;
          for (const val of this.data) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH: any = s.fileHierarchyVOArr;
                if (!fileH || fileH.length === 0) {
                  this.singleData.recipient.push({ empName: s.msg, unitId: 0 });
                  this.singleData.showMsg = true;
                  this.noPesronInForward = true;
                  //this.showMsg = true;
                } else {
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                    };
                    if (!recep.empName) {
                    } else {
                      this.singleData.recipient.push(recep);
                    }
                  }
                }
              }
              // else {
              //   this.singleData.recipient = 'No person is mapped above you';
              // }
            }
            this.SENDER_DATA.push(this.singleData);
            this.singleData = {
              docId: null,
              alphanum_Fileno: null,
              process: null,
              recipient: [],
              selectedRadio: null,
              showMsg: false,
            };
          }
        }
        this.forwardLevel = this.SENDER_DATA;
        this.getReturnData();
      });
  }

  getReturnData(): void {
    let params = new HttpParams();
    //this.docId =  this.caseData.docId
    params = params.append('appTypeId', '1');
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '611');
    params = params.append('recNo', this.refIdList);
    this.http
      .get('/workflow/hierarchy-details', { params: params })
      .subscribe((res: { data: ForwardData[] }) => {
        const restemp: { data: ForwardData[] } = res;

        this.singleData = {
          docId: null,
          alphanum_Fileno: null,
          process: null,
          recipient: [],
          selectedRadio: null,
          showMsg: false,
        };
        this.SENDER_DATA = [];
        if (!restemp.data.length) {
          this.noPesronInRetun = true;
          this.singleData.recipient.push({
            empName: 'No person is mapped above you',
            unitId: 0,
          });
          this.singleData.showMsg = true;
          //this.showMsg = true;
        } else {
          this.singleData.showMsg = false;
          //this.showMsg = false;
          for (const val of this.data) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH: any = s.fileHierarchyVOArr;
                if (!fileH || fileH.length === 0) {
                  this.singleData.recipient.push({ empName: s.msg, unitId: 0 });
                  this.singleData.showMsg = true;
                  this.noPesronInRetun = true;
                  //this.showMsg = true;
                } else {
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                    };
                    if (!recep.empName) {
                    } else {
                      this.singleData.recipient.push(recep);
                    }
                  }
                }
              }
              // else {
              //   this.singleData.recipient = 'No person is mapped above you';
              // }
            }
            this.SENDER_DATA.push(this.singleData);
            this.singleData = {
              docId: null,
              alphanum_Fileno: null,
              process: null,
              recipient: [],
              selectedRadio: null,
              showMsg: false,
            };
          }
        }
        this.returnLevel = this.SENDER_DATA;
        this.getSenderData();
      });
  }

  getSenderData(): void {
    let params = new HttpParams();
    //this.docId =  this.caseData.docId
    params = params.append('appTypeId', '1');
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '1');
    //params = params.append('recNo', this.refIdList);
    this.http
      .get('/workflow/hierarchy-details-revert', { params: params })
      .subscribe((res) => {
        let flag = 0;
        const restemp: any = res;
        this.SENDER_DATA = [];
        this.singleData = {
          docId: null,
          alphanum_Fileno: null,
          process: null,
          recipient: [],
          selectedRadio: null,
          showMsg: false,
        };
        if (!restemp.data.length) {
          this.singleData.recipient.push({
            empName: 'No person is mapped above you',
            unitId: 0,
          });
        } else {
          for (const val of this.data) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH = s.fileHierarchyVOArr;
                if (!fileH) {
                  this.singleData.recipient.push(s.msg);
                  flag = 0;
                } else {
                  flag = 1;
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                    };
                    if (!recep.empName) {
                    } else {
                      this.singleData.recipient.push(recep);
                    }
                  }
                }
              }
            }
            this.SENDER_DATA.push(this.singleData);
          }
        }

        if (flag === 1) {
          let flag1 = false;
          this.SENDER_DATA?.forEach((unit) => {
            this.returnLevel?.forEach((rUnit) => {
              rUnit?.recipient?.forEach((rec) => {
                if (
                  unit?.recipient[0]?.unitId?.toString()?.trim() ===
                  rec?.unitId?.toString()?.trim()
                ) {
                  flag1 = true;
                  return;
                }
              });
              if (flag1) {
                return;
              }
            });
            if (flag1) {
              return;
            }
          });
          // if (flag1) {
          //   this.senderLevel = [];
          // } else {
          this.senderLevel = this.SENDER_DATA;
          //}
        }
        this.getInitiatorData();
      });
  }

  initiator = {
    initiatorName: null,
    dsgnName: null,
    postId: null,
  };
  getInitiatorData(): void {
    let params = new HttpParams();
    //this.docId =  this.caseData.docId
    params = params.append('appTypeId', '1');
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '10000080');
    //params = params.append('recNo', this.refIdList);
    this.http
      .get('/workflow/hierarchy-details-revert', { params: params })
      .subscribe((res) => {
        let flag = 0;
        const restemp: any = res;
        this.SENDER_DATA = [];
        this.singleData = {
          docId: null,
          alphanum_Fileno: null,
          process: null,
          recipient: [],
          selectedRadio: null,
          showMsg: false,
        };
        if (!restemp.data.length) {
          this.singleData.recipient.push({
            empName: 'No person is mapped above you',
            unitId: 0,
          });
        } else {
          for (const val of this.data) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH = s.fileHierarchyVOArr;
                if (!fileH) {
                  this.singleData.recipient.push(s.msg);
                  flag = 0;
                } else {
                  flag = 1;
                  for (const m of fileH) {
                    this.initiator.initiatorName = m?.empName;
                    this.initiator.postId = this.caseData?.initiatorPostId;
                    this.initiator.dsgnName = m?.unitName;
                  }
                }
              }
            }
          }
        }
      });
    // this.initiator.initiatorName = this.caseData?.initiator;
    // this.initiator.initiatorOrgName = this.caseData?.Section;
    // this.initiator.postId = this.caseData?.initiatorPostId;
  }

  onSendCase(): void {
    console.log('on Send Case', this.selectedUnit);
    this.postData.refId.push(Number(this.caseData.docId));
    this.postData.toUnit.push(this.selectedUnit?.unitId);
    this.postData.toOrderNo.push(this.selectedUnit?.toOrderNo);
    this.postData.toMpgType.push(this.selectedUnit?.mpgType);
    if (this.selectedUnit?.actionType === 'f') {
      if (this.selectedUnit?.mpgType === 657) {
        this.postData.roleId.push(this.selectedUnit?.roleId);
      } else {
        this.postData.roleId.push(-1);
      }
      if (this.selectedUnit?.mpgType === 658) {
        this.postData.toGrpId = this.selectedUnit?.unitId;
        this.postData.toType = 1970;
      }
    } else if (this.selectedUnit?.actionType === 'r') {
      if (this.selectedUnit?.mpgType === 657) {
        this.postData.roleId.push(this.selectedUnit?.roleId);
      } else {
        this.postData.roleId.push(-1);
      }
    } else if (this.selectedUnit?.actionType === 'sender') {
      if (this.selectedUnit?.mpgType === 657) {
        this.postData.roleId.push(this.selectedUnit?.roleId);
      } else {
        this.postData.roleId.push(-1);
      }
    }
    this.http
      .post('/workflow/workflow-operation', this.postData)
      .subscribe((res) => {
        this.dialogRef.close(true);
      });
  }

  handleChange(event, actionName): void {
    console.log('on radio change', event);
    event.value.actionType = actionName;
    this.selectedUnit = event?.value;
  }

  isButtonDisable(): boolean {
    return this.selectedUnit ? false : true;
  }
}
